<template>

    <base-filter :name="name" :label="label">
        <div class="p-3">
            <div class="input-group">
                <input type="number" 
                       step=".0001"
                       class="form-control" 
                       :min="min"
                       :max="max"
                       v-model.lazy="range.min" />
                <span class="input-group-text">{{ __('to') }}</span>
                <input type="number" 
                       step=".0001"
                       class="form-control" 
                       :min="min"
                       :max="max"
                       v-model.lazy="range.max" />
                <span class="input-group-text">{{ __('€') }}</span>
            </div>
            <!--        @todo multi range slider    <div class="mt-3">
                            <label for="customRange3" class="form-label">Example range</label>
                            <input type="range" class="form-range" min="0" max="5" step="0.5" id="customRange3">
                        </div>-->
        </div>
    </base-filter>

</template>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>

<script>
    import BaseFilter from '@/shared/Filters/BaseFilter';
    import TextInput from '@/shared/Inputs/TextInput';

    export default {
        props: {
            name: String,
            label: String,
            min: [String, Number],
            max: [String, Number],
            value: Object,
        },
        components: {
            BaseFilter,
            TextInput,
        },
        data() {
            return {
                range: this.value
            }
        },
        methods: {
            handleInput(e) {
                console.log(e);
                this.$emit('input', this.range);
            },
            handleChange(e) {
                console.log(e);
                this.$emit('change', this.range);
            },
        }
    }
</script>
